import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import NewOrder from '../../components/order/NewOrder'
import Bridge from '../Bridge'
import { OrderProvider } from '../../components/provider/OrderProvider'
import { getToken, getVerifyAccessToken } from '../../api/login'
import { useCommonContext } from '../../components/provider/CommonProvider'

export default function OrderPage() {
  const navigate = useNavigate()

  const { hasAccessToken } = useCommonContext()

  useEffect(() => {
    // 회원 상태일 때 진입 시 회원 정보 API 호출로 토큰 만료 감지
    const token = getToken()
    if (!hasAccessToken || !token) return
    const checkProfile = async () => {
      try {
        const { data } = await getVerifyAccessToken(token)
        if (data.message !== 'ok') {
          alert('로그인이 필요합니다')
          navigate('/', { replace: true })
        }
      } catch (err: any) {
        if (err?.response?.status === 401) {
          alert('로그인이 필요합니다')
          navigate('/', { replace: true })
        }
      }
    }
    checkProfile()
  }, [hasAccessToken, navigate])

  return (
    <OrderProvider>
      <Bridge />
      <NewOrder />
    </OrderProvider>
  )
}
